module.exports = __webpack_public_path__ + "static/media/checkbox-small-on.5874a0fe.svg";